module.exports = __webpack_public_path__ + "static/img/5.3f2339c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-de-mascotas/5.png
// module id = Ueoj
// module chunks = 0